import React from "react";

import FloatingNav, {
  FloatingNavActions,
  FloatingNavTab,
  FloatingNavTabs,
} from "@app/analytics/components/reports/FloatingNav";
import StickyContainerWithBanner from "@app/analytics/MeetingReport/components/StickyContainerWithBanner";
import useTranscriptStore from "@app/analytics/MeetingReport/stores/transcript";

import CoachingSettings from "./CoachingSettings";
import CoachingEducationBanner from "../CoachingEducationBanner";

export type CoachingSection = "clarity" | "inclusion" | "impact";

interface MeetingReportCoachingSubNavProps {
  onSectionSelect: (section: CoachingSection, scrollToSection: boolean) => void;
  selectedSection: CoachingSection;
}

const MeetingReportCoachingSubNav = ({
  selectedSection,
  onSectionSelect,
}: MeetingReportCoachingSubNavProps) => {
  const handleSectionChange = (
    event: React.SyntheticEvent,
    section: CoachingSection
  ) => onSectionSelect(section, true);

  const transcriptAvailable = useTranscriptStore(
    (state) => state.transcriptAvailable
  );

  return (
    <StickyContainerWithBanner
      banner={CoachingEducationBanner}
      bannerDismissedLocalStorageKey="meetingReportCoachingBannerDismissed"
    >
      <FloatingNav>
        <FloatingNavTabs value={selectedSection} onChange={handleSectionChange}>
          <FloatingNavTab label="Clarity" value="clarity" />
          <FloatingNavTab label="Inclusion" value="inclusion" />
          <FloatingNavTab label="Impact" value="impact" />
        </FloatingNavTabs>
        {transcriptAvailable && (
          <FloatingNavActions>
            <CoachingSettings />
          </FloatingNavActions>
        )}
      </FloatingNav>
    </StickyContainerWithBanner>
  );
};

export default MeetingReportCoachingSubNav;
